import { Injectable } from '@angular/core';
import { Diagnostico, Desconexion, Etapa } from './diagnostico/Diagnostico.entity';

@Injectable()
export class DiagnosticoService {

  private _diagnostico: Diagnostico[] = [
    { tipoDesconexionID: 1 ,  titulo: 'Esencia y Forma' ,  desconexionesID: [1 ], desconexiones: null ,
     dimension: null , capa: null , dimensionID: 1 ,  capaID: null ,  rangoMayor: 0.4 ,  rangoMenor: 0.6 ,
      solucionesID: [null ] , soluciones: [null ] , etapaID: null  , etapa: null  },
      { tipoDesconexionID: 2 ,  titulo: 'Sentido de direccion' ,  desconexionesID: [2 ], desconexiones: null ,
      dimension: null , capa: null , dimensionID: 2 ,  capaID: 1 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6 ,
      solucionesID: [null] , soluciones: [null], etapaID: null , etapa: null  },
     { tipoDesconexionID: 3 ,  titulo: 'Capacidad y diseño organizativo' ,  desconexionesID: [3 ],
      desconexiones: null , dimension: null , capa: null , dimensionID: 3 ,  capaID: 2 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6,
      solucionesID: [null] , soluciones: [null] , etapaID: null , etapa: null  },
     { tipoDesconexionID: 4 ,  titulo: 'Cultura ' ,  desconexionesID: [4 ], desconexiones: null ,
      dimension: null , capa: null , dimensionID: 4 ,  capaID: 3 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6 ,
      solucionesID: [null] , soluciones: [null] , etapaID: null  , etapa: null },
     { tipoDesconexionID: 5 ,  titulo: 'Desconexion Transversal' ,  desconexionesID: [5 ],
      desconexiones: null , dimension: null , capa: null , dimensionID: 5 ,  capaID: 4 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6,
      solucionesID: [null] , soluciones: [null] , etapaID: null , etapa: null  },
     { tipoDesconexionID: 6 ,  titulo: 'Liderazgo' ,  desconexionesID: [6 ], desconexiones: null ,
      dimension: null , capa: null , dimensionID: 6 ,  capaID: 5 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6,
      solucionesID: [null] , soluciones: [null] , etapaID: null  , etapa: null  },
     { tipoDesconexionID: 7 ,  titulo: 'Disrupcion y Cambio' ,  desconexionesID: [2, 7],
      desconexiones: null , dimension: null , capa: null , dimensionID: 2 ,  capaID: 1 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6 ,
      solucionesID: [null] , soluciones: [null], etapaID: null  , etapa: null  },
     { tipoDesconexionID: 8 ,  titulo: 'Reconfiguracion del mismo ciclo' ,  desconexionesID: [2, 8],
      desconexiones: null , dimension: null , capa: null , dimensionID: 1 ,  capaID: 1 ,  rangoMayor: 0.4 ,  rangoMenor: 0.6 ,
      solucionesID: [null] , soluciones: [null] , etapaID: null  , etapa: null }
          ];

       private _desconexion: Desconexion[];




  constructor() { }


  GetAll(): Diagnostico[] {
    return this._diagnostico;
  }

  Get(id: number): Diagnostico {
    const  index = this._diagnostico.findIndex( (a) => a.tipoDesconexionID === id);
    if (index < 0) {
      return null;
    }
    return this._diagnostico[index];
  }

  Add(diagnostico: Diagnostico): number {

    diagnostico.tipoDesconexionID = new Date().valueOf(); // "unique" id
    this._diagnostico.push(diagnostico);
    return diagnostico.tipoDesconexionID;
  }

  Delete(id: number): void {

    const  index = this._diagnostico.findIndex( (a) => a.tipoDesconexionID === id);
    this._diagnostico.splice(index, 1);

  }

  Update(diagnostico: Diagnostico) {
    const  index = this._diagnostico.findIndex( (a) => a.tipoDesconexionID === diagnostico.tipoDesconexionID);
    if (index >= 0) {
      this._diagnostico[index] = diagnostico;
    } else {
      throw  new Error('diagnostico inexistente');
    }
  }

  FindbyNombreOApellido(nombre: string): Diagnostico[] {
    return this._diagnostico
                .filter( a => (a.titulo ).toLowerCase().indexOf(nombre.toLocaleLowerCase()) >= 0);
  }

}




// WEBPACK FOOTER //
// ./src/app/diagnostico.service.ts